import { CTATheme } from "../../components/common/CallToAction";

const CTAStyle = (theme: string, customStyle?: any, disabled?: boolean) => {
    let style: any = {}
    switch (theme) {
        case CTATheme.PRIMARY:
            style = {
                borderRadius: 30,
                backgroundImage: "linear-gradient(90deg,#ff2e73,#ff2e73)",
                color: "#FFF",
                marginRight: 10,
                textAlign: "center",
                outline: "none",
                border: "1px solid #ff2e73",
                padding: "10px 20px",
                fontFamily: "BrandonTextWeb-Medium",
                cursor: "pointer"
            }
            if (disabled) {
                style.pointerEvents = "none"
                style.backgroundImage = "linear-gradient(to right, #bbb, #888)"
                style.cursor = "not-allowed"
                style.opacity = 0.5
                style.border = 0;
            }
            break
        case CTATheme.SECONDARY:
            style = {
                borderRadius: 30,
                background: "transparent",
                color: "#e4306e",
                marginRight: 10,
                textAlign: "center",
                outline: "none",
                border: "1px solid #e4306e",
                padding: "10px 20px",
                fontFamily: "BrandonTextWeb-Medium",
                cursor: "pointer"
            }
            break
        case CTATheme.TEXTUAL:
            style = {
                display: "inline",
                fontSize: 14,
                margin: "4px 25px 0",
                color: "#ff316d",
                fontFamily: "BrandonTextWeb-Bold",
                cursor: "pointer",
                padding: '12px 0'
            }
            break
        case CTATheme.TEXTUAL_UNDERLINE:
            style = {}
            break
        case CTATheme.LIGHT:
            style = {
                borderRadius: 30,
                color: "#a59898",
                marginRight: 10,
                textAlign: "center",
                outline: "none",
                padding: "10px 20px",
                fontFamily: "BrandonTextWeb-Medium",
                cursor: "pointer",
                border: "1.1px solid rgb(185, 185, 185)"
            }
    }
    return { ...style, ...customStyle }
}

export default CTAStyle